import { Injectable } from '@angular/core';

import { GroupStoreService } from '@shure/cloud/device-management/shared/services';

import { CloudRoomsApiService } from '../api/cloud-rooms-api.service';
import { GroupsApiService } from '../api/groups-api.service';
import { InventoryDevicesApiService } from '../api/inventory-devices-api.service';

@Injectable({ providedIn: 'root' })
export class GroupStoreSyncService {
	constructor(
		private readonly groupsApiService: GroupsApiService,
		private readonly cloudRoomsApiService: CloudRoomsApiService,
		private readonly inventoryDevicesApiService: InventoryDevicesApiService,
		private readonly groupStoreService: GroupStoreService
	) {
		this.subscribeToGroupEvents();
		this.subscribeToCloudRoomEvents();
		this.subscribeToDeviceEvents();
	}

	private subscribeToGroupEvents(): void {
		this.groupsApiService.groupAdded$.subscribe((group) => {
			this.groupStoreService.addGroup(group);
		});

		this.groupsApiService.groupRemoved$.subscribe((groupId) => {
			this.groupStoreService.removeGroup(groupId);
		});

		this.groupsApiService.groupSnapshot$.subscribe((updatedGroup) => {
			let existingGroup;

			try {
				existingGroup = this.groupStoreService.getGroup(updatedGroup.id);
			} catch {
				this.groupStoreService.addGroup(updatedGroup);
				return;
			}

			if (existingGroup.name !== updatedGroup.name) {
				this.groupStoreService.renameGroup(updatedGroup.id, updatedGroup.name);
			}

			if (existingGroup.parentId !== updatedGroup.parentId && updatedGroup.parentId !== undefined) {
				this.groupStoreService.moveGroup(updatedGroup.id, updatedGroup.parentId);
			}
		});

		this.groupsApiService.suspended$.subscribe(() => {
			this.groupStoreService.clear();
		});
	}

	private subscribeToCloudRoomEvents(): void {
		this.cloudRoomsApiService.cloudRoomAdded$.subscribe((cloudRoom) => {
			this.groupStoreService.addCloudRoom(cloudRoom);
		});

		this.cloudRoomsApiService.cloudRoomRemoved$.subscribe((cloudRoomId) => {
			this.groupStoreService.removeCloudRoom(cloudRoomId);
		});

		this.cloudRoomsApiService.cloudRoomSnapshot$.subscribe((cloudRoom) => {
			this.groupStoreService.addCloudRoom(cloudRoom);
		});
	}

	private subscribeToDeviceEvents(): void {
		this.inventoryDevicesApiService.deviceGroupAssigned$.subscribe(({ deviceId, groupId }) => {
			this.groupStoreService.setDeviceGroup(deviceId, groupId);
		});

		this.inventoryDevicesApiService.deviceRemovedFromGroup$.subscribe((deviceId) => {
			this.groupStoreService.removeDevice(deviceId);
		});
	}
}
